// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Card: {
    select: 'Επιλογή',
    titleLinkTooltip: 'Μετάβαση στη σελίδα',
    collapseCardTooltip: 'Σύμπτυξη κάρτας',
    expandCardTooltip: 'Ανάπτυξη κάρτας'
  },
  CardList: {
    loadMore: 'Φόρτωση περισσότερων',
    notFound: 'Δεν βρέθηκαν στοιχεία.',
    toolbarSelect: 'Επιλογή',
    viewCards: 'Κάρτες',
    viewTiles: 'Πλακίδια',
    viewList: 'Λίστα',
    toolbarView: 'Προβολή'
  },
  ClosingConfirmation: {
    confirm: 'Έξοδος',
    cancel: 'Επιστροφή',
    content: 'Θέλετε σίγουρα να κλείσετε αυτό το παράθυρο; Δεν θα είναι δυνατή η αποθήκευση τυχόν αλλαγών σε δεδομένα.'
  },
  Cuttable: {
    showMore: 'Εμφάνιση περισσότερων',
    showLess: 'Εμφάνιση λιγότερων'
  },
  Dialog: {
    cancelButton: 'Ακύρωση'
  },
  DrawerProgress: {
    cancelButton: 'Ακύρωση'
  },
  Dropdown: {
    close: 'Κλείσιμο'
  },
  Form: {
    submitButton: 'Αποθήκευση',
    applyButton: 'Εφαρμογή',
    cancelButton: 'Ακύρωση'
  },
  FormField: {
    clear: 'Απαλοιφή',
    remove: 'Κατάργηση',
    addMore: 'Προσθήκη επιπλέον στοιχείου'
  },
  FormFieldPassword: {
    improvePassword: 'Για να βελτιώσετε τον κωδικό πρόσβασής σας:',
    passwordTooShort: 'Αυξήστε το μήκος του κωδικού πρόσβασης.',
    lettersLowerCase: 'Χρησιμοποιήστε τουλάχιστον έναν πεζό χαρακτήρα.',
    lettersUpperCase: 'Χρησιμοποιήστε τουλάχιστον έναν κεφαλαίο χαρακτήρα.',
    numbers1: 'Χρησιμοποιήστε τουλάχιστον έναν αριθμό.',
    numbers3: 'Χρησιμοποιήστε τουλάχιστον τρεις αριθμούς.',
    specialChar1: 'Χρησιμοποιήστε τουλάχιστον έναν ειδικό χαρακτήρα (για παράδειγμα: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Χρησιμοποιήστε τουλάχιστον δύο ειδικούς χαρακτήρες (για παράδειγμα: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Χρησιμοποιήστε κεφαλαίους και πεζούς χαρακτήρες.',
    comboLettersAndNumbers: 'Χρησιμοποιήστε αριθμούς και χαρακτήρες.',
    comboLettersNumbersSpecial: 'Χρησιμοποιήστε αριθμούς, χαρακτήρες και ειδικούς χαρακτήρες.',
    yourPasswordIsStrong: 'Μπορείτε να κάνετε τον κωδικό πρόσβασης πιο ισχυρό αυξάνοντας το μήκος του.',
    passwordStrength: 'Ισχύς κωδικού πρόσβασης: %%strength%%.',
    strengthVeryStrong: 'ΠΟΛΥ ΙΣΧΥΡΟΣ',
    strengthStrong: 'ΙΣΧΥΡΟΣ',
    strengthVeryWeak: 'ΠΟΛΥ ΑΔΥΝΑΜΟΣ',
    strengthWeak: 'ΑΔΥΝΑΜΟΣ',
    strengthMedium: 'ΜΕΤΡΙΟΣ',
    hidePassword: 'Απόκρυψη κωδικού πρόσβασης',
    showPassword: 'Εμφάνιση κωδικού πρόσβασης',
    generateButton: 'Δημιουργία',
    copyButtonHint: 'Αντιγραφή κωδικού πρόσβασης',
    copySuccessToast: 'Ο κωδικός πρόσβασης αντιγράφηκε',
    generateButtonHint: 'Δημιουργία ισχυρού κωδικού πρόσβασης'
  },
  InPlaceEdit: {
    editButtonHint: 'Επεξεργασία τιμής',
    okButtonHint: 'Αποθήκευση αλλαγών',
    cancelButtonHint: 'Απόρριψη αλλαγών'
  },
  InputFile: {
    browseButton: 'Επιλογή αρχείου...'
  },
  List: {
    totalRows: '%%totalRows%% στοιχεία συνολικά',
    selectedRows: '%%selectedRows%% από %%totalRows%% στοιχεία επιλέχθηκαν',
    all: 'Όλα',
    allItemsOnPageSelected: 'Επιλέχθηκαν όλα τα στοιχεία στη σελίδα',
    allItemsSelected: 'Επιλέχθηκαν όλα τα στοιχεία',
    selectAllItems: 'Επιλογή όλων των στοιχείων',
    selectAllItemsOnPage: 'Επιλογή όλων των στοιχείων στη σελίδα',
    deselectAll: 'Αποεπιλογή'
  },
  ListEmptyView: {
    filteredTitle: 'Δεν ήταν δυνατή η εύρεση στοιχείων που να ταιριάζουν με το φίλτρο',
    emptyTitle: 'Φαίνεται ότι δεν υπάρχει τίποτα εδώ',
    filteredDescription: 'Βελτιστοποιήστε το ερώτημά σας ή αφαιρέστε κάποια από τα κριτήρια από το φίλτρο και δοκιμάστε ξανά.'
  },
  ListOperation: {
    cancelButton: 'Ακύρωση'
  },
  Pagination: {
    totalShort: 'από %%total%%',
    itemsPerPage: 'Στοιχεία ανά σελίδα',
    all: 'Όλες',
    total: 'Σελίδα %%current%% από %%total%%'
  },
  ProgressDialog: {
    closeButton: 'Κλείσιμο',
    cancelButton: 'Ακύρωση'
  },
  Select: {
    noOptions: 'Δεν υπάρχουν επιλογές',
    placeholder: 'Επιλογή...'
  },
  SpotPopup: {
    total: '%%current%% από %%total%%'
  },
  Toaster: {
    closeGroup: 'Κλείσιμο ομάδας'
  }
};